import { Services } from "components/Constants";
import React from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { blueGradient, shadow } from "theme/GlobalElements";
import ServiceBarItemDesktop from "./ServiceBarItemDesktop";

const ServicesBarDesktop = () => {
  return (
    <ServicesBarDesktopContainer>
      <SVGsContainer>
        {Services.map((service, idx) => {
          return <ServiceBarItemDesktop key={idx} text={service.text} icon={service.icon} />;
        })}
      </SVGsContainer>
    </ServicesBarDesktopContainer>
  );
};

const ServicesBarDesktopContainer = styled.div`
  ${shadow};
  ${blueGradient};
  margin: 20px 30px;
  padding: 10px 20px;
`;

const SVGsContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-evenly;
  padding: 10px 20px;
  border: 1px solid white;
  @media only screen and (${device.tablet}) {
    flex-flow: row nowrap;
  }
`;

export default ServicesBarDesktop;
